import React from 'react';

import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CheckCircleOutline, Close } from '@material-ui/icons';
import { func } from 'prop-types';

const useStyles = makeStyles(theme => ({
  boxRoot: {
    backgroundColor: theme.palette.primary.lightest,
    color: theme.palette.neutral.darkest,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
}));

const SaveQuoteConfirmation = ({ closeConfirmation }) => {
  const classes = useStyles();

  return (
    <Box position="absolute" top="50px" zIndex={10} py={1} width={360} className={classes.boxRoot} display="flex">
      <Box mx={1} display="flex">
        <CheckCircleOutline color="primary" />
      </Box>
      <Typography variant="body2">Order has been saved.</Typography>
      <Box ml="auto" mr={1} display="flex" onClick={closeConfirmation}>
        <Close />
      </Box>
    </Box>
  );
};

SaveQuoteConfirmation.propTypes = {
  closeConfirmation: func.isRequired,
};

export default SaveQuoteConfirmation;
